export enum ServiceStatus {
    UNKNOWN,
    INACTIVE,
    ARCHIVED,
    DELETED,
    LIVE,
    PRIVATE
}